import React from "react";

const testimonials = [
  {
    name: "Brian Simmons",
    role: "VP Product",
    company: "Fondo",
    image: "https://randomuser.me/api/portraits/men/33.jpg",
    text: "I like being able to find information quickly. If anyone comes up with a new crazy idea or feature request, I can show them how many companies want it vs. other things—Safora is truly magical in that way!"
  },
  {
    name: "Christopher Byrum",
    role: "VP Product",
    company: "Puls",
    image: "https://randomuser.me/api/portraits/men/32.jpg",
    text: "Safora ensures we're making decisions based on data we can trust and gives stakeholders visibility into results without constant back-and-forth. It's our product strategy hub."
  },
  {
    name: "Josh Christensen",
    role: "Founder & CTO",
    company: "Hona",
    image: "https://randomuser.me/api/portraits/men/56.jpg",
    text: "Safora is a lifesaver for us! Everyone is now aligned on the product at all times, and our roadmap is transparent like never before."
  },
  {
    name: "Todd Wilkens",
    role: "Chief Product Officer",
    company: "Qualio",
    image: "https://randomuser.me/api/portraits/men/58.jpg",
    text: "Holding product strategy at scale is insanely complicated. Safora helps us manage thousands of feedback items, features, and initiatives across teams effortlessly."
  },
  {
    name: "Tom Mayblum",
    role: "Product Group Lead",
    company: "Armis",
    image: "https://randomuser.me/api/portraits/men/46.jpg",
    text: "Understanding customer health, commitments, and resource allocation is something I'm always chasing. Safora helps me stay on top of it all."
  },
  {
    name: "Zack Pennington",
    role: "Chief Product Officer",
    company: "Forecastr",
    image: "https://randomuser.me/api/portraits/men/36.jpg",
    text: "Being able to tie feature requests directly to their revenue impact is a unique and valuable lens. Safora nails product analysis like no other."
  },
  {
    name: "Guy Yasoor",
    role: "Product Manager",
    company: "Hunters",
    image: "https://randomuser.me/api/portraits/men/76.jpg",
    text: "We're excited about Safora and how it helps align feature requests and customer needs. It's already impacting how we prioritize!"
  }
];

export const TestimonialSection = () => {
  // Split testimonials into two rows
  const row1 = [...testimonials.slice(0, Math.ceil(testimonials.length / 2))];
  const row2 = [...testimonials.slice(Math.ceil(testimonials.length / 2))];

  return (
    <section className="w-full bg-white py-16 md:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="flex justify-center mb-2">
            <span className="text-sm font-medium text-gray-500 px-4 py-1 bg-gray-100 rounded-full">
              💬 Loved by experts
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            A community of product thinkers
          </h2>
          <p className="mt-2 text-base md:text-lg text-gray-600">
            <a href="#" className="text-blue-600 hover:underline">
              Join our Slack community
            </a>{" "}
            and see what the hype is all about.
          </p>
        </div>

        {/* Testimonials Container */}
        <div className="space-y-6">
          {/* Row 1 */}
          <div className="relative">
            <div className="absolute inset-y-0 left-0 w-16 md:w-32 bg-gradient-to-r from-white to-transparent z-10" />
            <div className="absolute inset-y-0 right-0 w-16 md:w-32 bg-gradient-to-l from-white to-transparent z-10" />
            <div className="overflow-hidden">
              <div className="animate-scroll flex gap-4 md:gap-6">
                {[...row1, ...row1].map((item, idx) => (
                  <div
                    key={`row1-${idx}`}
                    className="w-[300px] md:w-[500px] flex-shrink-0 bg-white border border-gray-200 shadow-sm rounded-xl p-4 md:p-6"
                  >
                    <p className="text-sm md:text-base text-gray-800 mb-4 md:mb-6">{item.text}</p>
                    <div className="flex items-center gap-3 md:gap-4">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-8 h-8 md:w-10 md:h-10 rounded-full object-cover"
                      />
                      <div>
                        <p className="text-xs md:text-sm font-semibold text-gray-900">{item.name}</p>
                        <p className="text-xs md:text-sm text-gray-500">
                          {item.role} at {item.company}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Row 2 */}
          <div className="relative">
            <div className="absolute inset-y-0 left-0 w-16 md:w-32 bg-gradient-to-r from-white to-transparent z-10" />
            <div className="absolute inset-y-0 right-0 w-16 md:w-32 bg-gradient-to-l from-white to-transparent z-10" />
            <div className="overflow-hidden">
              <div className="animate-scroll flex gap-4 md:gap-6" style={{ animationDelay: '-20s' }}>
                {[...row2, ...row2].map((item, idx) => (
                  <div
                    key={`row2-${idx}`}
                    className="w-[300px] md:w-[500px] flex-shrink-0 bg-white border border-gray-200 shadow-sm rounded-xl p-4 md:p-6"
                  >
                    <p className="text-sm md:text-base text-gray-800 mb-4 md:mb-6">{item.text}</p>
                    <div className="flex items-center gap-3 md:gap-4">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-8 h-8 md:w-10 md:h-10 rounded-full object-cover"
                      />
                      <div>
                        <p className="text-xs md:text-sm font-semibold text-gray-900">{item.name}</p>
                        <p className="text-xs md:text-sm text-gray-500">
                          {item.role} at {item.company}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};